import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { SubBar, MainView, Button, HintView, FormControl, PaginationNavigation, Message } from "lib/index";
import { open as openEditCompanyMemberModal } from "modules/settings/EditCompanyMemberModal/index";
import { stateSelector, initializeView, destroyView, fetchMembers, changePagination, setSearch } from "./index";
import CompanyMembersList from "./CompanyMembersList";
import Hint from "./CompanyMembersHint";

@connect(
  (state) => ({
    currentUserId: state.auth.user.id,
    members: stateSelector(state).members.model,
    fetchDone: stateSelector(state).members.fetchDone,
    fetchLoading: stateSelector(state).members.fetchLoading,
    fetchFailed: stateSelector(state).members.fetchFailed,
    offset: stateSelector(state).offset,
    limit: stateSelector(state).limit,
    search: stateSelector(state).search,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
        destroyView,
        fetchMembers,
        openEditCompanyMemberModal,
        changePagination,
        setSearch,
      },
      dispatch
    )
)
export default class CompanyMembersView extends React.PureComponent {
  componentDidMount() {
    this.props.initializeView();
  }

  componentWillUnmount() {
    this.props.destroyView();
  }

  handleNewMemberClick(event) {
    this.props.openEditCompanyMemberModal();
  }

  render() {
    const { members, currentUserId, fetchDone, fetchLoading, fetchFailed, fetchMembers, offset, limit, search, changePagination, setSearch } = this.props;
    const items = (members && members.records) || [];
    const totalCount = (members && members.meta && members.meta.total_count) || 0;

    return (
      <MainView.Container>
        <SubBar hasSidebar>
          <div className="pull-left u-inlineFlexRow">
            <h1>{I18n.t("papp.settings.CompanyMembersView.title")}</h1>
            <FormControl.Input
              value={search}
              onChange={(query) => setSearch(query)}
              placeholder={I18n.t("papp.common.search")}
              className="u-marginLeft c-inputStandard"
            />
          </div>
          <div className="pull-right u-inlineFlexRow">
            {fetchDone && totalCount > 0 && (
              <PaginationNavigation
                offset={offset}
                limit={limit}
                totalCount={totalCount}
                onChange={changePagination}
                name="membersLimit"
              />
            )}
            <Button primary as="a" className="u-marginLeft" onClick={this.handleNewMemberClick.bind(this)}>
              {I18n.t("papp.settings.CompanyMembersView.new_member")}
            </Button>
          </div>
        </SubBar>
        <MainView.Content hasSubBar padded={false}>
          <MainView.Dimmer loading={fetchLoading} failed={fetchFailed} retry={fetchMembers} />

          <HintView.Container>
            <HintView.Content>
              {fetchDone && totalCount === 0 && !search && (
                <Message>{I18n.t("papp.settings.CompanyMembersView.no_members")}</Message>
              )}
              {fetchDone && items.length === 0 && search && (
                <Message>{I18n.t("papp.common.no_results_message")}</Message>
              )}
              {fetchDone && items.length > 0 && (
                <CompanyMembersList
                  currentUserId={currentUserId}
                  members={items}
                  onMemberClick={(member) => this.props.openEditCompanyMemberModal(member)}
                />
              )}
            </HintView.Content>
            <HintView.Sidebar>
              <Hint />
            </HintView.Sidebar>
          </HintView.Container>
        </MainView.Content>
      </MainView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/settings/CompanyMembersView/CompanyMembersView.jsx